module.exports = __webpack_public_path__ + "static/img/pic-index-banner1.0056bbb.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/pic-index-banner1.png
// module id = 183
// module chunks = 0